import axios from 'axios';
import { Message as msg, MessageBox } from 'element-ui';

import ctt from '@/utils/const';
import EnvUtils from '@/utils/EnvUtils';

import { getLang } from '@/locale';
import { getToken, backToLogin, blobToObj } from '@/utils/utils';

let msbNum = 0;
const noToken = ['admin/login'];

const baseUrl = EnvUtils.get('BASE_URL');

const noCheck = [
  `${baseUrl}/echart/downLoadPdf`,
  `${baseUrl}/echart/exportAll`,
  `${baseUrl}/echart/exportOdpsByEventId`
];

const instance = axios.create({
  baseURL: baseUrl,
  timeout: ctt.AXIOS_TIMEOUT
});

const Message = (function () {
  const map = {};
  const throttle = key => {
    map[key] = true;
    const timer = setTimeout(() => {
      clearTimeout(timer);
      delete map[key];
    }, 500);
  };
  return function (params) {
    if (!map[params.message]) {
      throttle(params.message);
      msg(params);
    }
  };
})();

// 请求前拦截器
instance.interceptors.request.use(
  config => {
    if (noToken.indexOf(config.url) === -1) {
      if (getToken()) {
        config.headers['token'] = getToken(); // 让每个请求携带自定义token 请根据实际情况自行修改
        config.headers['lang'] = getLang() === 'zh-CN' ? 'zh' : getLang();
      }
    }
    return config;
  },
  err => {
    Message({
      type: 'warning',
      message: err,
      showClose: true
    });
    return Promise.reject(err);
  }
);

// 响应拦截器
instance.interceptors.response.use(
  async res => {
    if (noCheck.indexOf(res.config.url) > -1) {
      return res.data;
    } else {
      if (res.data instanceof Blob) {
        if (res.data.type === 'application/json') {
          const obj = await blobToObj(res.data);
          Message({ type: 'warning', message: obj.message || '请求出错' });
          return Promise.reject(new Error(obj.message || '请求出错'));
        } else {
          const headerName = res.headers['content-disposition'];
          const fileName = decodeURIComponent(headerName).substring(20);
          return {
            blob: res.data,
            fileName: fileName
          };
        }
      } else if (res.data.code === 200) {
        return res.data;
      } else {
        if (!res.config.disableDefTips) {
          Message({ type: 'warning', message: res.data.message || '请求出错' });
        }

        return Promise.reject(new Error(res.data.message || '请求出错'));
      }
    }
  },
  err => {
    if (err.response) {
      const status = err.response.status;
      if (status >= 500) {
        Message({
          type: 'warning',
          message: '服务器错误，请检查网络连接情况',
          showClose: true
        });
      } else if (status >= 400 && status < 500) {
        if (status === 403) {
          if (err.response.config.url.indexOf('auth/logout') > -1) {
            backToLogin();
          } else {
            msbNum++;
            if (msbNum === 1) {
              MessageBox.alert('请重新登录', '提示', {
                showClose: false,
                confirmButtonText: '重新登录',
                type: 'warning'
              }).then(() => {
                msbNum = 0;
                backToLogin();
              });
            }
          }
        } else {
          Message({
            type: 'warning',
            message: err.response.data.error ? err.response.data.error : '请求出错',
            showClose: true
          });
        }
      }
      return Promise.reject(err);
    } else if (err.code === 'ECONNABORTED') {
      Message({ type: 'warning', message: '用户所处环境网络信号不好（用户向服务器请求超时）' });
      Promise.reject(err);
    }
  }
);

export default instance;
